// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__MSPWB","buttons":"styles_buttons__3_jLs"};